"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getNamespace2 = _interopRequireDefault(require("./getNamespace"));
var _default = exports.default = function _default(_ref) {
  var market = _ref.market,
    namespace = _ref.namespace;
  var _getNamespace = (0, _getNamespace2.default)(namespace),
    appConfig = _getNamespace.appConfig,
    _getNamespace$i18n = _getNamespace.i18n,
    i18n = _getNamespace$i18n === void 0 ? {} : _getNamespace$i18n,
    _getNamespace$scriptL = _getNamespace.scriptLoaded,
    scriptLoaded = _getNamespace$scriptL === void 0 ? false : _getNamespace$scriptL;
  var i18nContent = i18n[market];
  return {
    appConfig: appConfig,
    i18nContent: i18nContent,
    scriptLoaded: scriptLoaded
  };
};